var QuickAccess = function () {

	this.init = function () {
		$('[data-component="quick-access"] .row:not(:first-child)').slick({
			dots: false,
			slidesToShow: 4,
			infinite: false,
			arrows: false,
			adaptiveHeight: true,
			responsive: [{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
						dots: true
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
						dots: true
					}
				}
			]
		});

		if (window.innerWidth > 767) {
			equalizer();
		}

		$(window).on('resize', function () {
			equalizer();
		})

		function equalizer() {
			var textMaxHeight = 0;
			var titleMaxHeight = 0;
			if (window.innerWidth <= 767) {
				$("[data-component='quick-access'] .primary-text, .secondary-title").css('height', 'auto');

			} else {
				$("[data-component='quick-access'] .primary-text").each(function () {
					$(this).css('height', 'auto');
					if ($(this).outerHeight() > textMaxHeight) {
						textMaxHeight = $(this).outerHeight();
					}
				});
				$("[data-component='quick-access'] .primary-text").outerHeight(textMaxHeight);

				$("[data-component='quick-access'] .secondary-title").each(function () {
					$(this).css('height', 'auto');
					if ($(this).outerHeight() > titleMaxHeight) {
						titleMaxHeight = $(this).outerHeight();
					}
				});
				$("[data-component='quick-access'] .secondary-title").outerHeight(titleMaxHeight);
			}
		}
	}

	return this.init();
}
